import { useEffect, useContext } from "react";
import { StoreContext } from "../../store/Store";
import { Rnd } from "react-rnd";
import { ScreenShotButtons } from "./ScreenShotButtons";
import { calculateAspectRatioFit } from "./utils";
import { actionTypes } from "../../store/storeTypes";
import { ShowPDF } from "./ShowPDF";

const MAXWIDTH = 500;

const containerStyle = {
  position: "absolute",
  backgroundColor: "#ffffff",
  border: "4px solid black",
};

const imageStyle = {
  pointerEvents: "none",
};

export const Screenshot = () => {
  const [store, dispatch] = useContext(StoreContext);
  const { screenshotImage, screenshotImageDimensions } = store;

  useEffect(() => {
    if (screenshotImage.type === "application/pdf") {
      window.open(screenshotImage.image, "_blank");
    } else {
      const img = new Image();
      img.src = screenshotImage.image;

      img.onload = () => {
        const dimensions = calculateAspectRatioFit(
          img.width,
          img.height,
          MAXWIDTH,
          3000
        );
        dispatch({
          type: actionTypes.SET_SCREENSHOT_IMAGE_DIMENSIONS,
          payload: dimensions,
        });
      };
    }
  }, [screenshotImage, dispatch]);

  return screenshotImage.active && screenshotImageDimensions ? (
    <Rnd
      default={{
        x: 0,
        y: 0,
        width: screenshotImageDimensions.width,
        height: screenshotImageDimensions.height,
      }}
      onResize={(e, direction, ref, delta, position) => {
        dispatch({
          type: actionTypes.SET_SCREENSHOT_IMAGE_DIMENSIONS,
          payload: {
            width: ref.offsetWidth,
            height: ref.offsetHeight,
          },
        });
      }}
    >
      <div
        style={{
          ...containerStyle,
          width: screenshotImageDimensions.width,
          height: screenshotImageDimensions.height,
        }}
      >
        <ScreenShotButtons />
        {screenshotImage.type === "application/pdf" ? (
          <ShowPDF
            screenshotImageDimensions={screenshotImageDimensions}
            screenshotImage={screenshotImage}
          />
        ) : (
          <img
            style={{
              ...imageStyle,
              width: screenshotImageDimensions.width,
              height: screenshotImageDimensions.height,
            }}
            alt="alt"
            src={screenshotImage.image}
          ></img>
        )}
      </div>
    </Rnd>
  ) : null;
};
